export const DatePickerEvent = {
	SELECT_CHANGE: 'onSelectChange',
	BEFORE_SELECT: 'onBeforeSelect',
	SELECT: 'onSelect',
	BEFORE_DESELECT: 'onBeforeDeselect',
	BEFORE_DAY_SELECT: 'onBeforeDaySelect',
	DESELECT: 'onDeselect',
	PRESET_SELECT: 'onPresetSelect',
	DESTROY: 'onDestroy',
};
